const WORDS = [
  "Kitchens", "Bathrooms", "Framing", "Tile", "Decks", "Flooring", "Painting", "Concrete", "Additions", "Renovations",
];

const Row = () => (
  <div className="flex items-center gap-8 pr-8 shrink-0">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center gap-8">
        <span className="font-display font-black text-4xl sm:text-6xl tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.35)]">
          {w}
        </span>
        <span className="h-2.5 w-2.5 rounded-full bg-[var(--apex-accent)]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  return (
    <div className="bg-[var(--apex-primary)] py-8 overflow-hidden border-y border-white/10" aria-hidden="true">
      <div className="flex w-max marquee-track">
        <Row />
        <Row />
      </div>
    </div>
  );
};
